import { dmpconnectMonitoringActionConstants } from '../constants';
import { getSessionId } from '../helpers';

export const startCpxMonitoring = () => (dispatch, getState) => (
  dispatch({
    type: dmpconnectMonitoringActionConstants.DMPC_CPX_MONITORING_START,
    command: {
      s_commandName: 'hl_startCpxCardMonitoring',
      i_checkingInterval: 5,
      s_sessionId: getSessionId(getState()),
    },
  })
);

export const stopCpxMonitoring = () => ({
  type: dmpconnectMonitoringActionConstants.DMPC_CPX_MONITORING_STOP,
});

export const updateCpxMonitoring = data => ({
  type: dmpconnectMonitoringActionConstants.DMPC_CPX_MONITORING_UPDATE,
  data,
});
